import { Actions, Atom, Namespace } from "@cirrus/fe-lib"

import { append, equals, filter, not, prop } from "ramda"
import { flow } from "fp-ts/es6/function"
import { put } from "redux-saga/effects"
import shortid from "shortid"

import { Notifications } from "../_params.js"

export const domain = Namespace.domain(Notifications, "loading")

export const actions = Actions.of(domain, ["add", "remove"])

const initialState = []

export const atom = Atom.behavior((on) => {
  on(actions.add, (state, { id, message }) => append({ id, message }, state))
  on(actions.remove, (state, { id }) => filter(flow(prop("id"), equals(id), not), state))
}, initialState)

export const effects = {
  *add({ message }) {
    const id = shortid.generate()

    yield put(actions.add({ id, message }))
    return id
  },

  *remove({ id }) {
    yield put(actions.remove({ id }))
  },
}
